import { gql } from "gql";

export const ENTITY_ATTRIBUTE_FRAGMENT = gql(/* GraphQL */ `
  fragment EntityAttribute on DynamicAttributeMetaDto {
    id
    name {
      value
      ...LocalizedValueDtoFragment
    }
    attributeCode
    description {
      value
      ...LocalizedValueDtoFragment
    }
    order

    ... on SimpleTypeDynamicAttributeDto {
      __typename
      type
    }

    ... on EnumTypeDynamicAttributeDto {
      enumId
      __typename
    }

    ... on LocalizedValueDynamicAttributeDto {
      __typename
    }

    ... on ReferenceTypeDynamicAttributeDto {
      __typename
    }
  }
`);

export const ENTITY_GROUP_FRAGMENT = gql(/* GraphQL */ `
  fragment EntityGroup on GroupDynamicAttributeValuesDto {
    order
    ...EntityAttributesSidebarViewGroup
    attributes {
      ...EntityAttribute
    }
  }
`);

export const GET_ENTITY_ATTRIBUTES = gql(/* GraphQL */ `
  query GetEntityAttributes(
    $entity: DynamicAttributeEntity!
    $category: String
  ) {
    getDynamicAttributeGroupMetaInfo(
      dynamicAttributeEntity: $entity
      category: $category
    ) {
      attributes {
        ...EntityAttribute
      }
      groups {
        ...EntityGroup
      }
    }
  }
`);
